'use client'

import type { PaymentLinkItemProps } from '@maestro/commerce-blocks/components/payments-list/payments-list.types'

import classNames from 'classnames'
import NextImage from 'next/image'
import React, { useCallback } from 'react'

import { useEventBusContext } from '@maestro/core/event/event-bus.context'
import { EventType } from '@maestro/data-layer'
import { Link } from '@pearlconvert/ui/components/link'

export default function PaymentLinkItem(props: PaymentLinkItemProps) {
  const { customClass, link, logo, newTab, title } = props
  const { publish } = useEventBusContext()

  const handleClickPayment = useCallback(() => {
    if (!link) {
      return null
    }
    publish(EventType.FOOTER_LINK_CLICKED, {
      level1: 'Payment Methods',
      level2: title,
      click_url: link,
      click_text: title,
    })
  }, [link, publish, title])

  const image = (
    <NextImage
      className={classNames({ [customClass || '']: !!customClass })}
      src={`/assets/icons/footer/${logo}`}
      width={101}
      height={25}
      alt={title}
      loading="lazy"
    />
  )

  return link ? (
    <Link
      href={link}
      target={newTab ? '_blank' : '_self'}
      onClick={handleClickPayment}
    >
      {image}
    </Link>
  ) : (
    image
  )
}
